import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    AvailabilityStatusUpdate,
    ConnectivityStatus,
    DisconnectedReason,
    initialConnectivityState,
} from 'app/store/connectivity/ConnectivityState';
import NetworkState from 'communication/NetworkState';
import { addItemToArrayWithMaxSize } from 'utils/arrays/arrayUtils';

export interface SetDisconnectedPayload {
    reason: DisconnectedReason;
    lostConnectionStatus?: NetworkState;
}

const connectivityStateSlice = createSlice({
    name: 'connectivity',
    initialState: initialConnectivityState,
    reducers: {
        setConnected: (state) => {
            const status: ConnectivityStatus = {
                connected: true,
                disconnectedReason: undefined,
                timestamp: new Date(),
            };
            state.current = status;
            state.history = addItemToArrayWithMaxSize(
                status,
                state.history,
                100
            );
        },
        setDisconnected: (
            state,
            action: PayloadAction<SetDisconnectedPayload>
        ) => {
            const status: ConnectivityStatus = {
                connected: false,
                timestamp: new Date(),
                disconnectedReason: action.payload!.reason,
                lostConnectionStatus: action.payload!.lostConnectionStatus,
            };
            state.current = status;
            state.history = addItemToArrayWithMaxSize(
                status,
                state.history,
                100
            );
        },
        addAvailabilityStatus: (
            state,
            action: PayloadAction<AvailabilityStatusUpdate>
        ) => {
            state.availabilityStatus.push(action.payload);
        },
    },
});

export const { addAvailabilityStatus, setConnected, setDisconnected } =
    connectivityStateSlice.actions;

export const connectivityReducer = connectivityStateSlice.reducer;
